module.exports = __webpack_public_path__ + "img/google-auth-logo.4f26e961.svg";